export default {
  nav: {
    width: '100%',
  },
  menuList: {
    padding: 0,
  },
};
